export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { href: '#index', label: '热门专题' },
    { href: '#carousel', label: '焦点推荐' },
    { href: '#ranking', label: '人气榜单' },
    { href: '#cards', label: '精选推荐' },
    { href: '#updates', label: '更新快讯' },
  ];

  const supportLinks = [
    { href: '#about', label: '关于我们' },
    { href: '#contact', label: '联系我们' },
    { href: '#faq', label: '常见问题' },
    { href: '#features', label: '平台优势' },
  ];

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl font-bold text-foreground-950">韩漫屋</span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              韩漫屋汇集海量韩漫全集免费资源，涵盖免费韩漫大全、韩漫免费全集在线，免注册全章节免费看，高清画质，支持下拉式阅读，追更连载第一时间更新。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-foreground-900 no-underline hover:text-primary-600 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors no-underline cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-foreground-900 no-underline hover:text-primary-600 transition-colors">支持</a>
            </h4>
            <ul className="space-y-2.5">
              {supportLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors no-underline cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">合作伙伴信息持续更新中</p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫屋 - 韩漫全集免费在线阅读平台
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学习交流，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}